import React, { Component } from 'react';
import { Button, Form, FormGroup, Modal, Row, Col, Container } from 'react-bootstrap';
import { Snackbar } from '@mui/material';
import { IconButton } from '@mui/material';


import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';




import FormationService from '../services/FormationService';



export class AddFormation extends Component {


    emptyItem = {
        name: '',
        duration: '',
        prices: [
            {
                price: '',
                payMode: '',
                contractEligible: '',
            }
        ],
        startPmTime: '13:00:00',
        startAmTime: '09:00:00',
        endPmTime:'17:00:00',
        endAmTime:'12:00:00',

    };

    
    minTime =  dayjs('2023-01-01T08:00:00');
    maxTime =  dayjs('2023-01-01T19:00:00');
    

    constructor(props) {
        super(props);
        this.state = {
            item: this.emptyItem,
            snackbaropen: false,
            nbPrices: 0,
            fiche: null,
            convocation: null,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeOne = this.handleChangeOne.bind(this);
        this.handleFicheChange = this.handleFicheChange.bind(this);
        this.handleConvocationChange = this.handleConvocationChange.bind(this);
        this.handleChangeTime = this.handleChangeTime.bind(this);
    }



    componentDidUpdate(previousProps, currentState) {
        //console.log('In add student :::');
        //console.log(this.props.currentcontract);
        if (previousProps.currentformation !== this.props.currentformation) {

            this.setState({ item: this.props.currentformation });
        }
    }




    handleChangeOne(event) {
        //console.log('In add student handleContractChange :::');
        //console.log(event);
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = { ...this.state.item };
        item[name] = value;
        this.setState({ item });
        //console.log('State after change');
        //console.log(item);
    }

    handleChange(i, event) {
        /* let formValues = this.state.item.prices;
         formValues[i][event.target.name] = event.target.value;
         this.setState({ formValues });
 */
        const name = event.target.name;
        console.log('handel event : ' + i);
        console.log(event.target.name);
        console.log(event.target.value);
        console.log("checkend");
        console.log(event.target.checked);

        let item = { ...this.state.item };
        if (name === "contractEligible") {
            item.prices[i][name] = event.target.checked;
        } else {
            item.prices[i][event.target.name] = event.target.value;
        }
        this.setState({ item });
        console.log(item);
    }

    handleFicheChange(e) {
        console.log(e);
        console.log(e.target.files[0]);
        this.setState({ fiche: e.target.files[0] });
    }

    handleConvocationChange(e) {
        console.log(e);
        console.log(e.target.files[0]);
        this.setState({ convocation: e.target.files[0] });
    }

    handleChangeTime(newValue, fieldName) {
        console.log(newValue);
        console.log(newValue.format('HH:mm:ss.SSS'));
        let item = { ...this.state.item };
        //item[fieldName] = newValue.$H+":"+newValue.$M;
        item[fieldName] = newValue.format('HH:mm:ss');
        //item[fieldName] = newValue;
        this.setState({ item });
    }


    handleSubmit(event) {
        event.preventDefault();
        const { item, fiche, convocation } = this.state;
        console.log(item)
        if (item.id) {
            FormationService.update(item.id, item, fiche, convocation)
                .then((response) => {
                    const {  message } = response.data;
                    //alert(message)
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                })
                .catch((err) => {
                    console.log(err);
                    const {  message } = err.response.data;
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                });
        } else {
            FormationService.create(item, fiche, convocation)
                .then((response) => {
                    const {  message } = response.data;
                    this.setState({ snackbaropen: true, snackbarmsg: message });
                })
                .catch((err) => {
                    console.log(err);
                    const { detail } = err.response.data;
                    this.setState({ snackbaropen: true, snackbarmsg: detail });
                });
        }

    }

    snackbarClose = (event) => {
        this.setState({ snackbaropen: false });
    }



    addFormFields() {
        //console.log('addFormFields');
        //console.log(this.state.item);
        let item = { ...this.state.item };
        var newPrice = { price: "", payMode: "" };
        item.prices.push(newPrice);
        this.setState({ item });


        //console.log(this.state.item);
    }

    removeFormFields(i) {
        //let formValues = this.state.formValues;
        let item = { ...this.state.item };
        item.prices.splice(i, 1);
        this.setState({ item });
    }




    render() {
        const { item } = this.state;
        //console.log('In render : ');
        //console.log(item);
       // console.log(this.MinTime);
        const titre = <h2>{item.id ? 'Modifier Formation' : 'Ajout Formation'}</h2>;

        

        //const dateVal =  dayjs('2023-01-13T12:00:00.208Z');
        const startAmTime =  dayjs('2023-01-01T'+ (item.startAmTime ));
        const startPmTime =  dayjs('2023-01-01T'+ ( item.startPmTime ));
        const endPmTime =  dayjs('2023-01-01T'+(item.endPmTime));
        const endAmTime =  dayjs('2023-01-01T'+(item.endAmTime));
        //console.log(dateVal);

        return (
            <div className='container'>

                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    open={this.state.snackbaropen}
                    autoHideDuration={3000}
                    onClose={this.snackbarClose}
                    message={<span id='message-id'> {this.state.snackbarmsg}  </span>}
                    action={[
                        <IconButton
                            key="close"
                            aria-label='Close'
                            color='inherit'
                            onClick={this.snackbarClose}
                        >X</IconButton>
                    ]}
                ></Snackbar>

                <Modal
                    {...this.props}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {titre}
                        </Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={this.handleSubmit}>
                        <Modal.Body>
                            <Container>

                                <Row>
                                    <Col xs={9} md={9}>

                                        <FormGroup controlId='name'>
                                            <Form.Label>Nom</Form.Label>
                                            <Form.Control type="text" size="sm" name='name' onChange={this.handleChangeOne} value={item.name || ''} required placeholder='Nom de la formation' />
                                        </FormGroup>
                                        <FormGroup controlId='id'>
                                            <Form.Control type="hidden" name='id' onChange={this.handleChangeOne} value={item.id || ''} />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={3} md={3}>
                                        <FormGroup controlId='duration'>
                                            <Form.Label>Durée</Form.Label>
                                            <Form.Control type="text" size="sm" name='duration' onChange={this.handleChangeOne} value={item.duration || ''} required placeholder='Durée' />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={9} md={9}>
                                        <Form.Group controlId="fiche" className="mb-3">
                                            <Form.Label>Fiche de programme</Form.Label>
                                            <Form.Control size="sm" type="file" name='fiche' onChange={this.handleFicheChange} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={9} md={9}>
                                        <Form.Group controlId="convocation" className="mb-3">
                                            <Form.Label>Modèle de convocation ODT (optionnel, sinon model standart par défaut)</Form.Label>
                                            <Form.Control size="sm" type="file" name='convocation' onChange={this.handleConvocationChange} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={3} md={3}>
                                        <FormGroup controlId='startAmTime'>
                                            <Form.Label>Matin</Form.Label>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <TimePicker
                                                    minTime={this.minTime}
                                                    maxTime={this.maxTime}
                                                    ampm={false}
                                                    label="heure début"
                                                    value={startAmTime}
                                                    onChange={newval => this.handleChangeTime(newval, 'startAmTime')}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={3} md={3}>
                                        <FormGroup controlId='endAmTime'>
                                        <Form.Label>Matin</Form.Label>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <TimePicker
                                                    ampm={false}
                                                    label="heure fin"
                                                    value={endAmTime}
                                                    onChange={newval => this.handleChangeTime(newval, 'endAmTime')}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={3} md={3}>
                                        <FormGroup controlId='startPmTime'>
                                        <Form.Label>Après-midi</Form.Label>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <TimePicker
                                                    ampm={false}
                                                    label="heure début"
                                                    value={startPmTime}
                                                    onChange={newval => this.handleChangeTime(newval, 'startPmTime')}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={3} md={3}>
                                        <FormGroup controlId='endPmTime'>
                                        <Form.Label>Après-midi</Form.Label>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <TimePicker
                                                    ampm={false}
                                                    label="heure fin"
                                                    value={endPmTime}
                                                    onChange={newval => this.handleChangeTime(newval, 'endPmTime')}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </FormGroup>
                                    </Col>

                                </Row>



                                {this.state.item.prices.map((element, index) => (
                                    <Row key={index}>
                                        <Col xs={4} md={4}>
                                            <FormGroup controlId='payMode'>
                                                <Form.Label>Mode de paiement</Form.Label>
                                                <Form.Select size="sm" aria-label="Mode Paiement" name='payMode' onChange={e => this.handleChange(index, e)} value={element.payMode || ''} required>
                                                    <option>Choisir une methode de paiement</option>
                                                    <option value="Autofinancement">Autofinancement</option>
                                                    <option value="CPF">CPF</option>
                                                    <option value="FAFCEA">FAFCEA</option>
                                                    <option value="POLE EMPLOI">POLE EMPLOI</option>
                                                    <option value="AUTRE">AUTRE</option>
                                                </Form.Select>
                                            </FormGroup>
                                        </Col>

                                        <Col xs={2} md={2}>
                                            <FormGroup controlId='price'>
                                                <Form.Label>Prix</Form.Label>
                                                <Form.Control size="sm" type="text" name='price' onChange={e => this.handleChange(index, e)} value={element.price || ''} required placeholder='Prix' />
                                            </FormGroup>
                                        </Col>

                                        <Col xs={3} md={3}>
                                            <FormGroup controlId='contractEligible'>
                                                <Form.Label>Eligible contrat</Form.Label>
                                                <Form.Check
                                                    type='checkbox'
                                                    id='contractEligible'
                                                    name='contractEligible'
                                                    checked={(element.contractEligible === true)}
                                                    label={element.contractEligible === true ? 'oui' : 'non'}

                                                    onChange={e => this.handleChange(index, e)}
                                                />
                                            </FormGroup>
                                        </Col>



                                        <Col xs={2} md={2}>
                                            <FormGroup>
                                                <Form.Label>&nbsp;</Form.Label>
                                                <Button variant="secondary" size="sm" onClick={() => this.removeFormFields(index)} >Supprimer</Button>
                                            </FormGroup>
                                        </Col>

                                    </Row>

                                ))}


                            </Container>


                        </Modal.Body>
                        <Modal.Footer>
                            <FormGroup>
                                <Button variant="secondary" onClick={() => this.addFormFields()} >Ajouter Prix</Button>
                            </FormGroup>
                            <FormGroup>
                                <Button variant="dark" type="submit" >Enregistrer</Button>
                            </FormGroup>
                            <Button variant='danger' onClick={this.props.onHide}>Fermer</Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </div>
        );
    }
}